<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  Form(
    v-show="!isSubmitting",
    :data="document",
    :isSubmitting="isSubmitting",
    :showFileUpload="true",
    :fileRequired="false",
    @submit="create"
  )
</template>

<script>
import { ref } from '@vue/composition-api'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { useRouter } from '@core/utils/utils'
import Form from '../shared/Form.vue'
import { getDeclarationConfig, tipoOptions } from '../declarationConfig'
import useDeclarationAdd from './useDeclarationAdd'

export default {
  components: {
    Form,
    Loading,
  },

  setup() {
    const { create, isSubmitting } = useDeclarationAdd()
    const { route } = useRouter()
    const config = getDeclarationConfig(route.value?.path)

    const defaultFechaRevision = new Date()
    defaultFechaRevision.setMonth(defaultFechaRevision.getMonth() + 12)

    // Pre-select "Tipo de Documento" when there is a single option (Conflict of Interest types).
    const typeOptions = tipoOptions.value[config.type] || []
    const defaultTipoDocumento = typeOptions.length === 1 ? typeOptions[0].value : null

    const document = ref({
      nombre: '',
      trabajador: null,
      institucion: '',
      empresas: [],
      area: null,
      tipoDocumento: defaultTipoDocumento,
      tematica: '',
      responsable: null,
      fechaReunion: null,
      observaciones: '',
      // Lobby: leave empty so it mirrors the meeting date once selected.
      fechaProximaRevision: config.showFechaReunion ? null : defaultFechaRevision.toISOString().split('T')[0],
    })

    return {
      document,
      create,
      isSubmitting,
    }
  },
}
</script>
